import React from 'react'
import emailIcon from '../../images/svg/nav/email.svg'
import './MailLink.scss'

const MailLink = ({ email = 'info@narative.sk', showIcon = true, showUnderline = true, className = '' }) => (
  <a className={`contact-link ${className}`.trim()} href={`mailto:${email}`}>
    {showIcon && <img src={emailIcon} alt='' className='contact-link-icon' />}
    {showUnderline
      ? <span className='contact-link-text'>{email}</span>
      : email
    }
  </a>
)

export default MailLink
